import React from "react";
import MultipleOfficesLP from "../MultipleOfficesLP";

function AllgemeinmedizinLP() {
  var officeArray = [
    {
      doctorName: "Vilma Navasaitis",
      doctorTitle: "FÄ für Allgemeinmedizin/Hausarzt",
      officeLoc: "Lauchhammer",
      navLink: "/allgemeinmedizin-hausarzt-navasaitis",
    },
    {
      doctorName: "Dr. Mohamed Ahmad",
      doctorTitle: "Facharzt für Allgemeinmedizin/Hausarzt",
      officeLoc: "Köthen",
      navLink: "/allgemeinmedizin-hausarzt-ahmad",
    },
    {
      doctorName: "Dr. med. Michaela Smago-Klose",
      doctorTitle: "Fachärztin für Allgemeinmedizin",
      officeLoc: "Lübbenau",
      navLink: "/allgemeinmedizin-hausarzt-smago-klose",
    },
    {
      doctorName: "Dipl.-Med. Petra Wilhelm",
      doctorTitle: "Internistin / Hausärztlich",
      officeLoc: "Lübbenau",
      navLink: "/allgemeinmedizin-hausarzt-wilhelm",
    },
  ];

  return (
    <MultipleOfficesLP
      officeType={"Allgemeinmedizin/Hausarzt"}
      officeArray={officeArray}
    />
  );
}

export default AllgemeinmedizinLP;
